import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui';

const Hero: React.FC = () => {
  const navigate = useNavigate();
  return (
    <section className="relative bg-gradient-to-br from-rowing-gray-50 to-white overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 -z-10">
        <svg
          className="absolute right-0 top-0 -mt-20 -mr-20 opacity-10"
          width="404"
          height="384"
          fill="none"
          viewBox="0 0 404 384"
        >
          <defs>
            <pattern id="grid" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
              <rect
                x="0"
                y="0"
                width="2"
                height="2"
                fill="currentColor"
                className="text-rowing-blue"
              />
            </pattern>
          </defs>
          <rect width="404" height="384" fill="url(#grid)" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
        <div className="lg:grid lg:grid-cols-2 lg:gap-8 items-center">
          {/* Text content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-5xl lg:text-6xl font-display font-bold text-rowing-navy leading-tight">
              Navigate Your Path to
              <span className="text-rowing-blue block">College Rowing</span>
            </h1>
            <p className="mt-6 text-xl text-rowing-gray-600 leading-relaxed">
              Connect with top rowing programs, showcase your achievements, and find your perfect
              college match. Built by rowers, for rowers.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <Button size="lg" onClick={() => navigate('/register')} className="px-8 py-4">
                Start Your Journey
              </Button>
              <Button
                variant="secondary"
                size="lg"
                onClick={() => navigate('/schools')}
                className="px-8 py-4"
              >
                Explore Schools
              </Button>
            </div>
            <div className="mt-8 flex items-center gap-8">
              <div>
                <p className="text-3xl font-bold text-rowing-navy">200+</p>
                <p className="text-rowing-gray-600">Rowing Programs</p>
              </div>
              <div>
                <p className="text-3xl font-bold text-rowing-navy">5,000+</p>
                <p className="text-rowing-gray-600">Student Athletes</p>
              </div>
              <div>
                <p className="text-3xl font-bold text-rowing-navy">95%</p>
                <p className="text-rowing-gray-600">Success Rate</p>
              </div>
            </div>
          </motion.div>

          {/* Image placeholder */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mt-12 lg:mt-0"
          >
            <div className="relative">
              <div className="aspect-[4/3] bg-gradient-to-br from-rowing-blue to-rowing-navy rounded-2xl shadow-2xl flex items-center justify-center">
                <p className="text-white text-2xl font-display">Hero Image</p>
              </div>
              {/* Floating accent */}
              <div className="absolute -bottom-6 -right-6 w-72 h-72 bg-rowing-red opacity-10 rounded-full blur-3xl -z-10"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
